module.exports = ( $scope, $uibModalInstance, sourceWorkflowPairs ) ->

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.ok = ->
    $uibModalInstance.close $scope.extra

  $scope.extra = ''

  $scope.sourceWorkflowPairs = sourceWorkflowPairs
